import { forwardRef, useRef, useState } from "react";
import { TextInput } from "@primer/react";
import { XIcon } from "@primer/octicons-react";
import "./ClearableTextInput.css";

export const ClearableTextInput = forwardRef(function ClearableTextInput({ clearLabel = "Clear text", disabled, onBlur, onClear, onFocus, readOnly, shortcutHint, trailingVisual, value, ...props }, ref) {
  const [focused, setFocused] = useState(false);
  const clearRef = useRef(null);
  const clearAction = focused && value && !disabled && !readOnly ? (
    <TextInput.Action
      ref={clearRef}
      icon={XIcon}
      aria-label={clearLabel}
      onBlur={() => setFocused(false)}
      onClick={onClear}
      onFocus={() => setFocused(true)}
    />
  ) : null;

  return (
    <TextInput
      {...props}
      disabled={disabled}
      readOnly={readOnly}
      ref={ref}
      trailingVisual={shortcutHint && !focused ? <kbd className="clearable-shortcut">{shortcutHint}</kbd> : trailingVisual}
      value={value}
      trailingAction={clearAction}
      onBlur={(event) => {
        if (event.relatedTarget !== clearRef.current) setFocused(false);
        onBlur?.(event);
      }}
      onFocus={(event) => {
        setFocused(true);
        onFocus?.(event);
      }}
    />
  );
});
